import { request } from './http';
import { cachedRead } from './readCache';

export async function getCompanies() {
  return cachedRead('companies', () => request('/customers/'));
}

export async function getCompanyAuditManagers(companyId) {
    return request(`/customers/${companyId}/audit-managers`);
  }

export async function setCompanyAuditManagers(companyId, userIds) {
    return request(`/customers/${companyId}/audit-managers`, {
      method: 'PUT',
      body: JSON.stringify({ auditManagers: userIds }),
    });
  }

export async function getCustomers() {
    return getCompanies();
  }

export async function getUserCompanyAssignments(userId) {
    return request(`/auth/user-company-assignments/${userId}`);
  }

export const customersCompaniesApi = {
  getCompanies,
  getCompanyAuditManagers,
  setCompanyAuditManagers,
  getCustomers,
  getUserCompanyAssignments,
};

